module.exports = __webpack_public_path__ + "img/at.8852f839.svg";